module.exports = __webpack_public_path__ + "static/img/homeright31.80c34ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/homeright31.png
// module id = fSKo
// module chunks = 13